import React from "react";
import { useNavigate } from "react-router-dom";
import { Search, Home } from "lucide-react";
import GradientBackground from "@/components/shared/GradientBackground";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-250px)] flex flex-col items-center justify-center p-4">
      <GradientBackground className="w-full max-w-3xl p-12 rounded-xl shadow-lg text-center">
        <h1 className="text-5xl font-bold mb-3">404</h1>
        <h2 className="text-xl font-semibold mb-6">Page Not Found</h2>
        <p className="mb-10 text-lg">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-white text-gray-800 font-medium rounded-md hover:bg-opacity-90 transition-all flex items-center justify-center gap-2"
          >
            <Home size={20} />
            <span>Home</span>
          </button>
          <button
            onClick={() => navigate("/search")}
            className="px-6 py-3 border border-white bg-transparent font-medium rounded-md hover:bg-white hover:bg-opacity-10 transition-all flex items-center justify-center gap-2"
          >
            <Search size={20} />
            <span>Search Properties</span>
          </button>
        </div>
      </GradientBackground>
    </div>
  );
};

export default NotFoundPage;
